import { render, staticRenderFns } from "./ModalDocumento.vue?vue&type=template&id=b89ed5c8&scoped=true"
import script from "./ModalDocumento.vue?vue&type=script&lang=js"
export * from "./ModalDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumento.vue?vue&type=style&index=0&id=b89ed5c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89ed5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b89ed5c8')) {
      api.createRecord('b89ed5c8', component.options)
    } else {
      api.reload('b89ed5c8', component.options)
    }
    module.hot.accept("./ModalDocumento.vue?vue&type=template&id=b89ed5c8&scoped=true", function () {
      api.rerender('b89ed5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/infoBase/modales/ModalDocumento.vue"
export default component.exports